import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-cream py-16 md:py-24" data-id="element-127">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-129">
          <div className="flex justify-center mb-6" data-id="element-130">
            <Shield className="w-20 h-20 text-gold" data-id="element-131" />
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-6" data-id="element-132">
            Sin riesgo. Si no es para ti, te devolvemos tu dinero.
          </h2>

          <div className="prose prose-lg max-w-none mb-8" data-id="element-133">
            <p className="text-dark/80 leading-relaxed mb-4" data-id="element-134">
              Queremos que entres con paz, no con duda. Por eso tienes{' '}
              <strong data-id="element-135">7 días completos</strong> para revisar el ebook completo.
              Si en ese tiempo sientes que el programa no es lo que necesitas,
              escríbenos y procesamos tu reembolso sin complicaciones ni
              condiciones escondidas.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-md mb-8" data-id="element-136">
            <h3 className="text-xl font-serif font-bold text-navy mb-4" data-id="element-137">
              ¿Cómo solicitarlo?
            </h3>
            <p className="text-dark/80 mb-4" data-id="element-138">
              Envía un correo a <strong data-id="element-139">[tu email de soporte]</strong> con el
              asunto:
            </p>
            <p className="text-navy font-semibold italic mb-4" data-id="element-140">
              "Garantía — Orden, Provisión y Abundancia"
            </p>
            <p className="text-dark/80 mb-4" data-id="element-141">
              dentro de los <strong data-id="element-142">7 días</strong> posteriores a tu compra.
            </p>
            <p className="text-dark/80" data-id="element-143">
              Respondemos en menos de <strong data-id="element-144">48 horas</strong>.
            </p>
          </div>

          <div className="bg-navy text-white py-4 px-6 rounded-lg inline-block" data-id="element-145">
            <p className="font-semibold flex items-center gap-2" data-id="element-146">
              <Shield className="w-5 h-5" data-id="element-147" />
              Garantía total de 7 días — Sin letra pequeña — Sin complicaciones
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}